import I18n from 'I18n';
import { OBJECT_TYPE } from 'framework-asset-preview-lib/internal/shared/constants/objectTypes';
export default function getFasLabel({
  fas,
  metric,
  objectTypeId
}) {
  if (fas && fas.counters) {
    var _fas$counters$value$f;
    return (_fas$counters$value$f = fas.counters.value.find(counter => counter.name === metric)) === null || _fas$counters$value$f === void 0 ? void 0 : _fas$counters$value$f.label;
  }
  if (objectTypeId === OBJECT_TYPE.MARKETING_EVENT || objectTypeId === OBJECT_TYPE.EXTERNAL_WEB_URL || objectTypeId === OBJECT_TYPE.OBJECT_LIST) {
    return I18n.text(`frameworkAssetPreviewLib.propertyLabel.${objectTypeId}.${metric}`);
  }
  return metric;
}